module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACFSURBVHgB3ZG9EYAgDIUf0crKEVzBEdyAFZzMFdyAESxdg8qz4fCnIhjkaHldvkveSy5AZdL7AL31WRaIWKWaBaozbEBiSQPvZij0bEBiYSakM4gMPCz8MWEdrciSBoUmhD9RnqVPUHeSi9JDJhoUDn8Xel8WNUosUMuq52XutKxRYnXpArgSaF9dFMD5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/training2/class/img/chevron-right.double2.png
// module id = BWbf
// module chunks = 96